import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost } from './api';
import {
  IIupdatePermissionsGroupByUser,
  IgetBackofficeConfigurationResponse,
  IgetLoggedUserPermissionsResponse
} from '../types/configuration.types';

const { REACT_APP_API_USERS } = process.env;

export const getBackofficePermissionsData = async (): Promise<IgetBackofficeConfigurationResponse> => {
  return apiGet<AxiosRequestConfig, IgetBackofficeConfigurationResponse>(
    `${REACT_APP_API_USERS}/user/permissions/backoffice`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getLoggedUserPermissions = async (uid: string): Promise<IgetLoggedUserPermissionsResponse> => {
  return apiGet<AxiosRequestConfig, IgetLoggedUserPermissionsResponse>(
    `${REACT_APP_API_USERS}/user/backoffice-permissions/${uid}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updatePermissionsGroupByUser = async (data: IIupdatePermissionsGroupByUser): Promise<void> => {
  return apiPost<AxiosRequestConfig, IIupdatePermissionsGroupByUser>(
    `${REACT_APP_API_USERS}/user-permission-group/update/by-user`,
    data
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const addUserToBackoffice = async (email: string): Promise<void> => {
  return apiPost<AxiosRequestConfig, { email: string }>(`${REACT_APP_API_USERS}/user/backoffice-access`, { email })
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const removeAccessToBackofficeForUser = async (email: string): Promise<void> => {
  return apiPost<AxiosRequestConfig, { email: string }>(`${REACT_APP_API_USERS}/user/backoffice-access/remove`, {
    email
  })
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};
